import { render, staticRenderFns } from "./ProfileSuggestion.vue?vue&type=template&id=682a83c9"
import script from "./ProfileSuggestion.vue?vue&type=script&lang=js"
export * from "./ProfileSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports